import { useAppVariant } from "@jugl-web/utils";
import { useEntityProvider } from "@web-src/modules/entities/providers/EntityProvider/useEntityProvider";
import { useCurrentPageNavConfig } from "@web-src/modules/navigation/hooks/useCurrentPageNavConfig";
import React, { useEffect } from "react";

export const AppVersionSetter: React.FC = () => {
  const { entity } = useEntityProvider();
  const { setVersion, version } = useAppVariant();
  const navConfig = useCurrentPageNavConfig();
  useEffect(() => {
    // NOTE: make sure that for cx pages we always set this version, in case anonymous entity
    let versionToSet = version;
    if (navConfig?.path.startsWith("cx")) {
      versionToSet = "cx";
    } else if (navConfig?.path?.includes("org-create")) {
      versionToSet = "general";
    } else if (entity) {
      if (entity.type === "cx") {
        versionToSet = "cx";
      } else {
        versionToSet = "general";
      }
    }
    if (versionToSet !== version) {
      setVersion(versionToSet);
    }
  }, [entity, setVersion, navConfig, version]);
  return null;
};
